import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/css/swiper.css';
import '@/assets/css/application.css';
import axios from './utils/axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

const config = require('@/../vue.config');
import {getTime,router_url,removeByIndex,base64ToBlob,imagePath} from './utils/index'
import {get,post} from './api/index'
import pagination from '@/components/pagination'
Vue.component('pagination',pagination);

import upload from '@/components/upload';
Vue.component('upload',upload);
import order_1_upload from '@/components/order_1_upload';
Vue.component('order_1_upload',order_1_upload);
import order_1_uploads from '@/components/order_1_uploads';
Vue.component('order_1_uploads',order_1_uploads);

import uploads from '@/components/uploads';
Vue.component('uploads',uploads);

import upload_local from '@/components/upload_local';
Vue.component('upload_local',upload_local);


import header_html from '@/components/header_html'
import footer_html from '@/components/footer_html'
Vue.component('footer_html',footer_html);
Vue.component('header_html',header_html);

Vue.prototype.getTime = getTime
Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.router_url = router_url
Vue.prototype.base64ToBlob = base64ToBlob
Vue.prototype.imagePath = imagePath
Vue.prototype.$get = get
Vue.prototype.$post = post

import router from './permission' // 权限
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js